type nationalityOptionsType = {
  value: string;
  label: string;
};

const nationalityOptions = (): nationalityOptionsType[] => [
  { value: 'brasileira', label: 'Brasileira' },
  { value: 'outra', label: 'Outra' },
];

export default nationalityOptions;
